import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex screen-min-height position-relative" }

import { onMounted } from "vue";
import { useHead } from "@unhead/vue";
import { useRoute } from "vue-router";
import Navbar from "@/components/navigation/NavbarComponent.vue";
import Sidebar from "@/components/navigation/Sidebar.vue";
import Footer from "@/components/navigation/FooterComponent.vue";
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | Advance Profile` : "Advance Profile";
  },
  meta: [{ name: "description", content: "" }],
});

const route = useRoute();

onMounted(() => {
  window.removeEventListener("storage", (e) => syncLocalStorage(e));
  window.addEventListener("storage", (e) => syncLocalStorage(e));
});

function syncLocalStorage(e: any): any {
  localStorage.setItem(e.key, e.newValue);
}

const isDesktop = useMediaQuery('(min-width: 992px)')

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_1, [
      (!_unref(route).meta.hideSidebar)
        ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("main", {
        class: _normalizeClass(['pb-5', {'px-5': !_unref(route).meta.hideSidebar && _unref(isDesktop)}, {'ps-5 pe-2': !_unref(route).meta.hideSidebar && !_unref(isDesktop)}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{'col-12': _unref(isDesktop)}, {'col-11 ms-auto': !_unref(isDesktop)}, {'col-xl-11': !_unref(route).meta.hideSidebar}])
        }, [
          _createVNode(_component_router_view)
        ], 2)
      ], 2)
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})